export default __webpack_public_path__ + "df62b8ff6eea1e6bc4bb2eef90ccf5ac.png";